import { Navigate, RouteObject, useLocation } from 'react-router-dom'
import { AssetsProtectionPage } from './assets-protection'
import { AssetsProtectionPayroll } from './payroll/payroll-route'
import { AssetsProtectionTheft } from './theft/theft-route'
import { AssetsProtectionSecure } from './secure/secure-route'
import { AssetsProtectionProvider } from './assets-protection-context'

const RedirectToPayroll = () => {
    const location = useLocation()
    return <Navigate to={`payroll${location.search}`} replace />
}

const AssetsProtectionWithProvider = () => {
    return (
        <AssetsProtectionProvider>
            <AssetsProtectionPage />
        </AssetsProtectionProvider>
    )
}

export const AssetsProtectionRoute: RouteObject = {
    path: '/assets-protection',
    element: <AssetsProtectionWithProvider />,
    children: [
        {
            index: true,
            element: <RedirectToPayroll />,
        },
        {
            path: 'payroll',
            element: <AssetsProtectionPayroll />,
        },
        {
            path: 'theft',
            element: <AssetsProtectionTheft />,
        },
        {
            path: 'secure',
            element: <AssetsProtectionSecure />,
        },
    ],
}
